<template>
  <v-layout column style="overflow-x: hidden;">

    <v-data-table
        class="document-table mb-4"
        :headers="folderViewMode !== 'presentation' ? headers : presentationModeHeaders"
        :items="documents"
        hide-actions

    >
      <template slot="items" slot-scope="props">
        <td
            v-if="folderViewMode !== 'presentation'"
            class="text-xs-center"
            @click.stop="showDocument(props.item)"
        >
          <v-avatar
              size="22"
              class="grey lighten-3 font-weight-bold"
              :data-documentId="props.item.id"
          >
            <span style="font-size: 12px">{{ props.index + 1 }}</span>
          </v-avatar>
        </td>
        <td
            :class="{'grey lighten-1': isDocumentSelected(props.item.id)}"
            @click.stop="showDocument(props.item)"
        >
          <v-layout justify-center align-center row wrap>
            <v-icon
                class="has-pending"
                size="8"
                v-if="documentPendingColor(props.item) !== null"
                :color="documentPendingColor(props.item)"
            >
              mdi mdi-circle
            </v-icon>
            <v-flex class="pa-2">
              <v-layout open-on-hover top offset-y row align-center>
                <v-icon class="mr-3">
                  {{ documentStateIcon(props.item.document_state.state) }}
                </v-icon>
                <v-layout column>
                  <v-flex>
                        <span class="caption grey--text text--darken-1">
                          {{ props.item.document_state.state === 'DocGo' ?
                              props.item.created_by.administrative_unit.abbreviation :
                              props.item.created_by.administrative_unit.abbreviation + ' (' + props.item.document_state.state + ')' }}
                        </span>
                  </v-flex>
                  <v-flex>
                    <highlighter
                        slot="activator"
                        class="body-2"
                        :searchWords="keywords"
                        :textToHighlight="truncate(props.item.document_type.name, { length: 100 })"
                        autoEscape
                        highlightClassName="highlight"
                    />
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout>
        </td>

        <td
            v-if="folderViewMode !== 'presentation'"
            class="caption text-xs-center"
            width="200"
            @click.stop="showDocument(props.item)"
        >
          <span class="user-card pa-0">
            <v-list-tile avatar>
              <v-list-tile-avatar color="grey" size="24" class="avatar-mw">
                <img
                    alt="Avatar"
                    :src="props.item.created_by.avatar.url"
                    v-if="props.item.created_by.avatar.url"
                >
                <span class="caption" v-else>{{ acronym(props.item.created_by.name) }}</span>
              </v-list-tile-avatar>
              <v-tooltip top>
                <v-list-tile-content slot="activator">
                  <v-list-tile-title class="body-1">{{ shortName(props.item.created_by.name) }}</v-list-tile-title>
                  <v-list-tile-sub-title
                      class="caption classText"
                  >{{ props.item.created_by.role.name }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <span>{{ props.item.created_by.administrative_unit.name }}</span>
              </v-tooltip>
            </v-list-tile>
          </span>
        </td>

        <td
            v-if="folderViewMode !== 'presentation'"
            class="caption text-xs-center"
            width="200"
            @click.stop="showDocument(props.item)"
        >
          <v-chip color="grey-lighten-1">
            <span class="grey--text text--darken-2 text-truncate">{{ props.item.docflow_number }}</span>
          </v-chip>
        </td>
        <td align-center class="caption text-xs-center"
            v-if="folderViewMode !== 'presentation'">
          <v-chip color="primary" outline>
            <span class="grey--text text--darken-2 text-truncate">
                <v-icon v-if="props.item.created_at" size="20" class="mr-2 mb-0">mdi-clock-fast</v-icon>
            </span>
            <span class="grey--text text--darken-2 text-truncate">
                {{ props.item.created_at | formatDateWithHours }}
            </span>
          </v-chip>
        </td>
      </template>

    </v-data-table>


    <document-dialog
        v-if="showDocumentDialog"
        :doc="selectedDocument"
        :showDocumentDialog="showDocumentDialog"
        @closeDocumentDialog="closeDocumentDialog"
    />
  </v-layout>
</template>

<script>
import format from 'date-fns/format';
import * as ptLocale from 'date-fns/locale/pt';
import DocumentDialog from '@/components/document/show/DocumentDialog';
import DocumentInfo from '@/components/document/list/DocumentInfo';
import Highlighter from 'vue-highlight-words';
import {isEmpty, find, last, truncate, startCase, lowerCase} from 'lodash';
import bus from '@/utils/event-bus';
import acronym from '@/utils/acronym'
import CurrentOwner from "../../inbox/CurrentOwner.vue";
import shortName from "../../../utils/short-name";


export default {
  name: 'DocumentList',
  components: {
    CurrentOwner,
    DocumentDialog,
    Highlighter,
    DocumentInfo,
  },
  props: {
    documents: {
      default: [],
    },
    searchDocumentString: {
      type: String,
      default: '',
    },
  },

  mounted() {
    console.log(this.documents)
    bus.$on('onCloseDocumentDialog', () => {
      this.showDocumentDialog = false;
    });
    if (this.$router.currentRoute.query.documentId) {
      const document = this.documents.find(item =>
          item.id === Number(this.$router.currentRoute.query.documentId));
      this.showDocument(document);
    }
  },
  data() {
    return {
      documentSrc: {},
      headers: [
        {
          text: 'Ordem',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Documento',
          align: 'center',
          sortable: false
        },
        {
          text: 'Usuário',
          align: 'center',
          sortable: false
        },
        {
          text: 'Nº do Documento',
          align: 'center',
          sortable: false
        },
        {
          text: 'Criado',
          align: 'center',
          sortable: false,
        },
      ],
      presentationModeHeaders: [
        {
          text: 'Documentos',
          align: 'left',
          sortable: false,
        },
      ],
      pages: 0,
      showDocumentDialog: false,
      selectedDocument: {},
    };
  },
  methods: {
    shortName,
    acronym,
    startCaseText(string) {
      return startCase(lowerCase(string));
    },
    last,
    truncate,
    formatDate(date) {
      if (date === new Date()) {
        return 'Hoje';
      }
      return format(date, `DD/MM/YYYY`, {locale: ptLocale});
    },
    documentStateIcon(state) {
      const statesIcon = {
        Minuta: 'mdi-file-compare',
        DocGo: 'mdi-file-document',
        Rascunho: 'mdi-file-hidden',
        'Rascunho de Minuta': 'mdi-file-hidden',
        Desvinculado: 'mdi-link-variant-off',
      };
      return statesIcon[state];
    },
    documentPendingColor(item) {
      if (item.has_pending_revision) {
        return 'amber';
      } else if (item.has_pending_signature) {
        return 'accent';
      }
      return null;
    },
    showDocument(doc) {
      this.selectedDocument = {...doc};
      if (this.folderViewMode !== 'presentation') {
        this.showDocumentDialog = true;
      } else {
        bus.$emit('load-pdf', last(doc.document_versions).file);
      }
    },
    closeDocumentDialog() {
      this.showDocumentDialog = false;
    },
    isDocumentSelected(docId) {
      return !isEmpty(this.selectedDocument)
          && this.selectedDocument.id === docId && this.folderViewMode === 'presentation';
    },
  },
  computed: {
    keywords() {
      return this.searchDocumentString.split(' ');
    },
    folderViewMode() {
      return this.$store.getters.folderViewMode;
    },
  },
  watch: {
    documents(val) {
      if (!isEmpty(this.selectedDocument)) {
        this.selectedDocument = find(val, ['id', this.selectedDocument.id]);
      }
    },
  },
};
</script>

<style scoped>
.document-table {
  padding-left: 3px;
  width: 100%;
}

.documents {
  overflow-y: hidden;
  height: 100%;
  margin-top: 24px;
}

td {
  cursor: pointer;
}

.full-height {
  height: 100%;
}

.highlight {
  background-color: rgba(255, 226, 0, 0.3);
}

.f-size {
  font-size: 10px;
}

.f-color {
  color: rgb(145, 145, 145);
}

.avatar {
  background-color: #616161 !important;
  padding: 3px;
  border-radius: 30px;
}

.avatar-mw {
  min-width: 38px;
}

  .classText {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 20ch;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/document/list/DocumentList.vue